import baseApp from '@/pages/innerAPP'
import App from './App'

;(async () => {
  const vm = await baseApp(App)
  vm.mount('#app')
})()
